import { PlannerProfileListSearchCriteria } from '../../../../models';

export class AutomotiveAftermarketProfileListLoad {
  public static readonly type = '[AutomotiveAftermarketProfileList] Load';
  constructor(public payload: PlannerProfileListSearchCriteria) {}
}

export class AutomotiveAftermarketProfileListInitialState {
  public static readonly type = '[AutomotiveAftermarketProfileList] Set Initial State';
}
